$easyreels_user_signin $mol_view
	start? null
	sub /
		<= Lead $mol_paragraph
			title @ \Record and upload video. Sign in with Telegram.
		<= Start $mol_button_major
			title @ \Sign in with Telegram
			click? <=> start?
